import React from "react";
import { Box, FormControl, Grid, Skeleton } from "@mui/material";

// Mirrors the shape of the Service Counts / toggles / submit button section
// while the existing order for a date+client+vendor is being fetched.
export default function OrderFormSkeleton({ serviceCount = 2 }) {
  const rows = Math.max(serviceCount, 1);

  return (
    <Box sx={{ mt: 2 }}>
     
      <FormControl fullWidth sx={{ mt: 3 }}>
        {Array.from({ length: 3 }).map((_, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              flexDirection: { xs: "row", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              gap: { xs: 1, sm: 2 },
              mb: 2,
            }}
          >
               <Skeleton variant="rounded" width={"50%"} height={32} />
            <Skeleton variant="rounded" width={"50%"} height={32} />
          </Box>
        ))}
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <Skeleton variant="rounded" height={42} />
      </FormControl>
    </Box>
  );
}
